export default {
  root: () => ({
    class: ["checkbox-root"],
  }),
  box: ({ instance, context }) => {
    const variant = instance?.variant || "primary";
    const size = instance?.size || "sm";
    return {
      class: [
        "checkbox-box",
        {
          "checkbox-box_primary": variant === "primary",
          "checkbox-box_secondary": variant === "secondary",
          "checkbox-box_disabled": context.disabled,
          "checkbox-box_checked": context.checked,
          "checkbox-box_invalid": context.invalid,
          "checkbox-box_md": size === "md",
        },
      ],
    };
  },
  icon: () => ({
    class: [],
  }),
  input: {
    class: ["checkbox-input"],
  },
};
